<template>
    <div :class="getClass()" @click="onClick">
        <slot name="default"></slot>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Provide, Inject, Prop } from '@/helpers/Decorators';

@Options({
    name: 'list-view-utils-card',
    inheritAttrs: false
})
export default class Card extends Vue
{
    @Prop()
    @Provide('index')
    public index: number;

    @Prop()
    @Provide('item')
    public item: any;

    @Inject('row-click')
    public rowClick: (item: any) => void;

    @Inject('row-class')
    public rowClass: (item: any) => Record<string, boolean> | string[] | string;

    public getClass(): any
    {
        if (this.rowClass)
        {
            return this.rowClass(this.item);
        }

        return {};
    }

    public onClick(): void
    {
        if (this.rowClick)
        {
            return this.rowClick(this.item);
        }
    }
}
</script>
